import React from 'react'

interface OrganizationJsonLdProps {
  title: string
  description: string
  brandName: string
}

export const OrganizationJsonLd: React.FC<OrganizationJsonLdProps> = ({
  title,
  description,
  brandName
}) => {
  const organizationData = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    'name': brandName || 'Oasis Spa',
    'legalName': 'Destiny Enterprises Co.,Ltd.',
    'url': 'https://oasisspa.net',
    'logo': 'https://oasisspa.net/static/images/logo.png',
    'description': description,
    'slogan': title,
    'email': 'cs@oasisspa.net',
    'address': {
      '@type': 'PostalAddress',
      'streetAddress': '131/44 Moo 1 Chang Puak',
      'addressLocality': 'Muang Chiang Mai',
      'addressRegion': 'Chiang Mai',
      'postalCode': '50300',
      'addressCountry': 'Thailand'
    },
    'contactPoint': [
      {
        '@type': 'ContactPoint',
        'contactType': 'reservations',
        'name': 'Thailand Spa Reservations Center',
        'areaServed': 'Thailand',
        'telephone': '+66 5392 0111',
        'email': 'res@oasisspa.net',
        'hoursAvailable': '08:30-21:30 daily'
      },
      {
        '@type': 'ContactPoint',
        'contactType': 'reservations',
        'name': 'Chiang Mai Reservations',
        'areaServed': 'Chiang Mai',
        'telephone': '+66 5392 0111'
      },
      {
        '@type': 'ContactPoint',
        'contactType': 'reservations',
        'name': 'Bangkok Reservations',
        'areaServed': 'Bangkok',
        'telephone': '+66 2262 2122'
      },
      {
        '@type': 'ContactPoint',
        'contactType': 'reservations',
        'name': 'Phuket Reservations',
        'areaServed': 'Phuket',
        'telephone': '+66 7633 7777'
      },
      {
        '@type': 'ContactPoint',
        'contactType': 'reservations',
        'name': 'Pattaya Reservations',
        'areaServed': 'Pattaya',
        'telephone': '+66 3811 5888'
      },
      {
        '@type': 'ContactPoint',
        'contactType': 'reservations',
        'name': 'China Reservations',
        'areaServed': 'China',
        'telephone': '+86 10 8524 1233'
      },
      {
        '@type': 'ContactPoint',
        'contactType': 'reservations',
        'name': 'Hong Kong Reservations',
        'areaServed': 'Hong Kong',
        'telephone': '+852 3678 6717'
      },
      {
        '@type': 'ContactPoint',
        'contactType': 'reservations',
        'name': 'Japan Reservations',
        'areaServed': 'Japan',
        'telephone': '+81-50-6864-8322'
      },
      {
        '@type': 'ContactPoint',
        'contactType': 'reservations',
        'name': 'Singapore Reservations',
        'areaServed': 'Singapore',
        'telephone': '+65-3-1592144'
      },
      {
        '@type': 'ContactPoint',
        'contactType': 'customer service',
        'name': 'Head Office',
        'telephone': '+66 5392 0123',
        'faxNumber': '+66 5392 0122',
        'email': 'cs@oasisspa.net'
      }
    ],
    'sameAs': [
      'https://www.facebook.com/Oasisspapage',
      'https://www.instagram.com/oasisspathailand/',
      'https://twitter.com/the_oasis_spa',
      'https://www.youtube.com/user/TheOasisSpa',
      'https://www.weibo.com/oasisthailand'
    ],
    'openingHoursSpecification': {
      '@type': 'OpeningHoursSpecification',
      'dayOfWeek': ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
      'opens': '08:30',
      'closes': '21:30'
    },
    'priceRange': '$$-$$$'
  }

  return (
    <script
      type='application/ld+json'
      dangerouslySetInnerHTML={{ __html: JSON.stringify(organizationData) }}
    />
  )
}
